import {connect} from "react-redux"
import styled from "styled-components"
import {DESKTOP_BREAKPOINT_EM} from "manager/views/components/Settlement/constants"

/**
 * A common styled component base for constraining max width.
 */
const SettlementMaxWidth = styled.div`
  width: 100%;
  max-width: ${DESKTOP_BREAKPOINT_EM}em;
`

export default connect(null, null)(SettlementMaxWidth)
